// Default
import CardTarjaEnqueteDefault from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefault.vue";
import CardTarjaEnqueteDefaultQRCODE from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefaultQRCODE.vue";
import CardTarjaEnqueteDefaultFullscreen from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefaultFullscreen.vue";
import CardTarjaEnqueteDefaultWithQRCode from "@/components/Cards/Enquetes/Tarjas/CardTarjaEnqueteDefaultWithQRCode.vue";

// SaiaJusta (code 35)
import CardTarjaEnqueteSaiaJusta from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJusta.vue";
import CardTarjaEnqueteSaiaJustaQRCODE from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJustaQRCODE.vue";
import CardTarjaEnqueteSaiaJustaFullscreen from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJustaFullscreen.vue";
import CardTarjaEnqueteSaiaJustaWithQRCode from "@/components/Cards/Enquetes/Tarjas/SaiaJusta/CardTarjaEnqueteSaiaJustaWithQRCode.vue";

// AngelicaAoVivo (code 126)
import CardTarjaEnqueteAngelica from "@/components/Cards/Enquetes/Tarjas/AngelicaAoVivo/CardTarjaEnqueteAngelica.vue";
import CardTarjaEnqueteAngelicaQRCODE from "@/components/Cards/Enquetes/Tarjas/AngelicaAoVivo/CardTarjaEnqueteAngelicaQRCODE.vue";
import CardTarjaEnqueteAngelicaWithQRCode from "@/components/Cards/Enquetes/Tarjas/AngelicaAoVivo/CardTarjaEnqueteAngelicaWithQRCode.vue";

// SelecaoSportv (code 129)
import CardTarjaEnqueteSelecaoSportv from "@/components/Cards/Enquetes/Tarjas/SelecaoSportv/CardTarjaEnqueteSelecaoSportv.vue";
import CardTarjaEnqueteSelecaoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/SelecaoSportv/CardTarjaEnqueteSelecaoSportvQRCODE.vue";
import CardTarjaEnqueteSelecaoSportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/SelecaoSportv/CardTarjaEnqueteSelecaoSportvWithQRCode.vue";

// CopaTVFechada (code 140)
import CardTarjaEnqueteCopaTVFechada from "@/components/Cards/Enquetes/Tarjas/CopaTVFechada/CardTarjaEnqueteCopaTVFechada.vue";
import CardTarjaEnqueteCopaTVFechadaQRCODE from "@/components/Cards/Enquetes/Tarjas/CopaTVFechada/CardTarjaEnqueteCopaTVFechadaQRCODE.vue";
import CardTarjaEnqueteCopaTVFechadaWithQRCode from "@/components/Cards/Enquetes/Tarjas/CopaTVFechada/CardTarjaEnqueteCopaTVFechadaWithQRCode.vue";

// SportTVNews (code 138)
import CardTarjaEnqueteSportTVNews from "@/components/Cards/Enquetes/Tarjas/SportTVNews/CardTarjaEnqueteSportTVNews.vue";
import CardTarjaEnqueteSportTVNewsQRCODE from "@/components/Cards/Enquetes/Tarjas/SportTVNews/CardTarjaEnqueteSportTVNewsQRCODE.vue";
import CardTarjaEnqueteSportTVNewsWithQRCode from "@/components/Cards/Enquetes/Tarjas/SportTVNews/CardTarjaEnqueteSportTVNewsWithQRCode.vue";

// TaNaAreaSportv (code 128)
import CardTarjaEnqueteTaNaAreaSportv from "@/components/Cards/Enquetes/Tarjas/TaNaAreaSportv/CardTarjaEnqueteTaNaAreaSportv.vue";
import CardTarjaEnqueteTaNaAreaSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/TaNaAreaSportv/CardTarjaEnqueteTaNaAreaSportvQRCODE.vue";
import CardTarjaEnqueteTaNaAreaSportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/TaNaAreaSportv/CardTarjaEnqueteTaNaAreaSportvWithQRCode.vue";

// TrocaDePassesSportv (code 127)
import CardTarjaEnqueteTrocaDePassesSportv from "@/components/Cards/Enquetes/Tarjas/TrocaDePassesSportv/CardTarjaEnqueteTrocaDePassesSportv.vue";
import CardTarjaEnqueteTrocaDePassesSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/TrocaDePassesSportv/CardTarjaEnqueteTrocaDePassesSportvQRCODE.vue";
import CardTarjaEnqueteTrocaDePassesSportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/TrocaDePassesSportv/CardTarjaEnqueteTrocaDePassesSportvWithQRCode.vue";

// TaOn (code 137)
import CardTarjaEnqueteTaOn from "@/components/Cards/Enquetes/Tarjas/TaOn/CardTarjaEnqueteTaOn.vue";
import CardTarjaEnqueteTaOnQRCODE from "@/components/Cards/Enquetes/Tarjas/TaOn/CardTarjaEnqueteTaOnQRCODE.vue";
import CardTarjaEnqueteTaOnWithQRCode from "@/components/Cards/Enquetes/Tarjas/TaOn/CardTarjaEnqueteTaOnWithQRCode.vue";

// F1Sportv (code 133)
import CardTarjaEnqueteF1Sportv from "@/components/Cards/Enquetes/Tarjas/F1Sportv/CardTarjaEnqueteF1Sportv.vue";
import CardTarjaEnqueteF1SportvQRCODE from "@/components/Cards/Enquetes/Tarjas/F1Sportv/CardTarjaEnqueteF1SportvQRCODE.vue";
import CardTarjaEnqueteF1SportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/F1Sportv/CardTarjaEnqueteF1SportvWithQRCode.vue";

// F1Globo (code 135)
import CardTarjaEnqueteF1Globo from "@/components/Cards/Enquetes/Tarjas/F1Globo/CardTarjaEnqueteF1Globo.vue";
import CardTarjaEnqueteF1GloboQRCODE from "@/components/Cards/Enquetes/Tarjas/F1Globo/CardTarjaEnqueteF1GloboQRCODE.vue";
import CardTarjaEnqueteF1GloboWithQRCode from "@/components/Cards/Enquetes/Tarjas/F1Globo/CardTarjaEnqueteF1GloboWithQRCode.vue";

// FechamentoSportv (code 130)
import CardTarjaEnqueteFechamentoSportv from "@/components/Cards/Enquetes/Tarjas/FechamentoSportv/CardTarjaEnqueteFechamentoSportv.vue";
import CardTarjaEnqueteFechamentoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/FechamentoSportv/CardTarjaEnqueteFechamentoSportvQRCODE.vue";
import CardTarjaEnqueteFechamentoSportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/FechamentoSportv/CardTarjaEnqueteFechamentoSportvWithQRCode.vue";

// RedacaoSportv (code 131)
import CardTarjaEnqueteRedacaoSportv from "@/components/Cards/Enquetes/Tarjas/RedacaoSportv/CardTarjaEnqueteRedacaoSportv.vue";
import CardTarjaEnqueteRedacaoSportvQRCODE from "@/components/Cards/Enquetes/Tarjas/RedacaoSportv/CardTarjaEnqueteRedacaoSportvQRCODE.vue";
import CardTarjaEnqueteRedacaoSportvWithQRCode from "@/components/Cards/Enquetes/Tarjas/RedacaoSportv/CardTarjaEnqueteRedacaoSportvWithQRCode.vue";

// TVZ (code 61)
import CardTarjaEnqueteTVZ from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZ.vue";
import CardTarjaEnqueteTVZFullScreen from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZFullScreen.vue";
import CardTarjaEnqueteTVZQRCODE from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZQRCODE.vue";
import CardTarjaEnqueteTVZWithQRCode from "@/components/Cards/Enquetes/Tarjas/TVZ/CardTarjaEnqueteTVZWithQRCode.vue";

/**
 * Component map defining which components are available for each production mode
 * Each production can have: qrcode, fullscreen, combined, and default modes
 */
export const ENQUETE_COMPONENT_MAP = {
  35: { // Saia Justa
    default: CardTarjaEnqueteSaiaJusta,
    qrcode: CardTarjaEnqueteSaiaJustaQRCODE,
    fullscreen: CardTarjaEnqueteSaiaJustaFullscreen,
    combined: CardTarjaEnqueteSaiaJustaWithQRCode
  },
  126: { // AngelicaAoVivo
    default: CardTarjaEnqueteAngelica,
    qrcode: CardTarjaEnqueteAngelicaQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteAngelicaWithQRCode
  },
  127: { // TrocaDePassesSportv
    default: CardTarjaEnqueteTrocaDePassesSportv,
    qrcode: CardTarjaEnqueteTrocaDePassesSportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteTrocaDePassesSportvWithQRCode
  },
  137: { // TaOn
    default: CardTarjaEnqueteTaOn,
    qrcode: CardTarjaEnqueteTaOnQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteTaOnWithQRCode
  },
  133: { // F1Sportv
    default: CardTarjaEnqueteF1Sportv,
    qrcode: CardTarjaEnqueteF1SportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteF1SportvWithQRCode
  },
  135: { // F1Globo
    default: CardTarjaEnqueteF1Globo,
    qrcode: CardTarjaEnqueteF1GloboQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteF1GloboWithQRCode
  },
  128: { // TaNaAreaSportv
    default: CardTarjaEnqueteTaNaAreaSportv,
    qrcode: CardTarjaEnqueteTaNaAreaSportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteTaNaAreaSportvWithQRCode
  },
  129: { // SelecaoSportv
    default: CardTarjaEnqueteSelecaoSportv,
    qrcode: CardTarjaEnqueteSelecaoSportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteSelecaoSportvWithQRCode
  },
  138: { // SportTVNews
    default: CardTarjaEnqueteSportTVNews,
    qrcode: CardTarjaEnqueteSportTVNewsQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteSportTVNewsWithQRCode
  },
  130: { // FechamentoSportv
    default: CardTarjaEnqueteFechamentoSportv,
    qrcode: CardTarjaEnqueteFechamentoSportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteFechamentoSportvWithQRCode
  },
  131: { // RedacaoSportv
    default: CardTarjaEnqueteRedacaoSportv,
    qrcode: CardTarjaEnqueteRedacaoSportvQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteRedacaoSportvWithQRCode
  },
  61: { // TVZ
    default: CardTarjaEnqueteTVZ,
    qrcode: CardTarjaEnqueteTVZQRCODE,
    fullscreen: CardTarjaEnqueteTVZFullScreen,
    combined: CardTarjaEnqueteTVZWithQRCode
  },
  140: { // CopaTVFechada
    default: CardTarjaEnqueteCopaTVFechada,
    qrcode: CardTarjaEnqueteCopaTVFechadaQRCODE,
    fullscreen: null,
    combined: CardTarjaEnqueteCopaTVFechadaWithQRCode
  }
};

/**
 * SporTV production codes
 * These productions have special behavior: they always show results with QR Code
 */
export const SPORTV_PRODUCTIONS = [127, 128, 129, 130, 131];

/**
 * Check if a production is a SporTV production
 * SporTV productions have special behavior for QR Code + results display
 * @param {number} codProducao - Production code
 * @returns {boolean} - True if the production is a SporTV production
 */
export function isSporTVProduction(codProducao) {
  return SPORTV_PRODUCTIONS.includes(Number(codProducao));
}

/**
 * Default components used when a production doesn't have specific components
 */
export const DEFAULT_ENQUETE_COMPONENTS = {
  default: CardTarjaEnqueteDefault,
  qrcode: CardTarjaEnqueteDefaultQRCODE,
  fullscreen: CardTarjaEnqueteDefaultFullscreen,
  combined: CardTarjaEnqueteDefaultWithQRCode
};

/**
 * Check if a production has a specific mode available
 * @param {number} codProducao - Production code
 * @param {string} mode - Mode to check ('qrcode', 'fullscreen', 'default')
 * @returns {boolean} - True if the mode is available for this production
 *
 * Logic:
 * - If production not in map → mode is ENABLED (uses default component)
 * - If mode is explicitly set to null or false → mode is DISABLED
 * - Otherwise → mode is ENABLED (uses custom or default component)
 */
export function hasEnqueteMode(codProducao, mode) {
  const productionConfig = ENQUETE_COMPONENT_MAP[codProducao];


  // If production not in maps, all modes are enabled (use defaults)
  if (!productionConfig) {
    return true;
  }

  // If a mode is not specified in the production config, it's enabled (use default)
  if (!(mode in productionConfig)) {
    return true;
  }

  // If the mode is explicitly set to null or false, it's disabled
  const modeValue = productionConfig[mode];
  if (modeValue === null || modeValue === false) {
    return false;
  }

  // Otherwise, mode is enabled
  return true;
}

/**
 * Get availability status for all modes at once (more efficient than multiple hasEnqueteMode calls)
 * @param {number} codProducao - Production code
 * @returns {object} - Object with boolean values for each mode: { default, fullscreen, qrcode }
 */
export function getAvailableModes(codProducao) {
  const productionConfig = ENQUETE_COMPONENT_MAP[codProducao];

  // If production not in maps, all modes are enabled
  if (!productionConfig) {
    return {
      default: true,
      fullscreen: true,
      qrcode: true,
    };
  }

  // Check each mode
  const checkMode = (mode) => {
    if (!(mode in productionConfig)) {
      return true; // Not specified → enabled
    }
    const modeValue = productionConfig[mode];
    return modeValue !== null && modeValue !== false; // Disabled only if explicitly null/false
  };

  return {
    default: checkMode('default'),
    fullscreen: checkMode('fullscreen'),
    qrcode: checkMode('qrcode'),
  };
}
